/* eslint-disable */
/*********************************************************
/ Glorious generated code by DoneDone's Code Generator.
/ Written by Ka Wai Cheung.
/ Don't modify this by hand silly!
*********************************************************/

import { RequestHandler } from '../request-handler'
import {
  INotificationsOutputNotification,
  IGenericJSONMessage,
} from '../types/response.types'

export default new class NotificationsAPI extends RequestHandler {
  /****** GET methods *****/
  public async get_Listing(
  ): Promise<INotificationsOutputNotification[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/notifications`,
    })
  }
  /****** POST methods *****/
  public async post_Read(
    notification_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/notifications/${notification_id}/read`,
    })
  }
  public async post_Clear(
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/notifications/clear`,
    })
  }
}()
